import { render, staticRenderFns } from "./admin-utilizadores.vue?vue&type=template&id=f0d3cc64&"
import script from "./admin-utilizadores.vue?vue&type=script&lang=js&"
export * from "./admin-utilizadores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports